<template>
  <div class="sidebar">
    <ul class="nav-list">
      <li class="nav-item" :class="{ expanded: expandedNavs['考试文件'] }">
        <div class="nav-title" @click="$emit('toggle-nav', '考试文件')">
          考试文件
          <span class="toggle-icon" :class="{ 'expanded': expandedNavs['考试文件'] }">▼</span>
        </div>
        <ul class="sub-nav" v-show="expandedNavs['考试文件']" :class="{ expanded: expandedNavs['考试文件'] }">
          <li class="sub-nav-item" :class="{ active: currentSubNav === '报考文件' }"
            @click="$emit('switch-nav', '考试文件', '报考文件')">报考文件</li>
          <li class="sub-nav-item" :class="{ active: currentSubNav === '网上报名流程' }"
            @click="$emit('switch-nav', '考试文件', '网上报名流程')">网上报名流程</li>
          <li class="sub-nav-item" :class="{ active: currentSubNav === '照片上传说明' }"
            @click="$emit('switch-nav', '考试文件', '照片上传说明')">照片上传说明</li>
          <li class="sub-nav-item" :class="{ active: currentSubNav === '登录说明' }"
            @click="$emit('switch-nav', '考试文件', '登录说明')">登录说明</li>
          <li class="sub-nav-item" :class="{ active: currentSubNav === '网上支付说明' }"
            @click="$emit('switch-nav', '考试文件', '网上支付说明')">网上支付说明</li>
        </ul>
      </li>
      <li class="nav-item" :class="{ expanded: expandedNavs['选择考试'] }">
        <div class="nav-title" @click="$emit('toggle-nav', '选择考试')">
          选择考试
          <span class="toggle-icon" :class="{ 'expanded': expandedNavs['选择考试'] }">▼</span>
        </div>
        <ul class="sub-nav" v-show="expandedNavs['选择考试']" :class="{ expanded: expandedNavs['选择考试'] }">
          <li class="sub-nav-item" :class="{ active: currentSubNav === '报名中' }"
            @click="$emit('switch-nav', '选择考试', '报名中')">报名中</li>
          <li class="sub-nav-item" :class="{ active: currentSubNav === '报名结束' }"
            @click="$emit('switch-nav', '选择考试', '报名结束')">报名结束</li>
        </ul>
      </li>
      <li class="nav-item" :class="{ expanded: expandedNavs['我的报名'] }">
        <div class="nav-title" @click="$emit('toggle-nav', '我的报名')">
          我的报名
          <span class="toggle-icon" :class="{ 'expanded': expandedNavs['我的报名'] }">▼</span>
        </div>
        <ul class="sub-nav" v-show="expandedNavs['我的报名']" :class="{ expanded: expandedNavs['我的报名'] }">
          <li class="sub-nav-item" :class="{ active: currentSubNav === '我的报名' }"
            @click="$emit('switch-nav', '我的报名', '我的报名')">我的报名</li>
          <li class="sub-nav-item" :class="{ active: currentSubNav === '成绩查询' }"
            @click="$emit('switch-nav', '我的报名', '成绩查询')">成绩查询</li>
          <li class="sub-nav-item" :class="{ active: currentSubNav === '准考证打印' }"
            @click="$emit('switch-nav', '我的报名', '准考证打印')">准考证打印</li>
        </ul>
      </li>
      <li class="nav-item" :class="{ expanded: expandedNavs['个人中心'] }">
        <div class="nav-title" @click="$emit('toggle-nav', '个人中心')">
          个人中心
          <span class="toggle-icon" :class="{ 'expanded': expandedNavs['个人中心'] }">▼</span>
        </div>
        <ul class="sub-nav" v-show="expandedNavs['个人中心']" :class="{ expanded: expandedNavs['个人中心'] }">
          <li class="sub-nav-item" :class="{ active: currentSubNav === '个人信息' }"
            @click="$emit('switch-nav', '个人中心', '个人信息')">个人信息</li>
          <li class="sub-nav-item" :class="{ active: currentSubNav === '修改密码' }"
            @click="$emit('switch-nav', '个人中心', '修改密码')">修改密码</li>
          <li class="sub-nav-item" :class="{ active: currentSubNav === '退出登录' }" @click="handleLogout">退出登录</li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Sidebar',
  props: {
    currentNav: String,
    currentSubNav: String,
    expandedNavs: Object
  },
  methods: {
    handleLogout() {
      // 不再在侧边栏使用原生 confirm，而是委托给父组件 Home 处理确认逻辑
      this.$emit('logout', false);
    }
  }
}
</script>

<style scoped>
.sidebar {
  width: 250px;
  background: linear-gradient(to bottom, #eaf4ff 0%, #d6eaff 50%, #c7e0ff 100%);
  border-radius: var(--radius-sm);
  box-shadow: var(--shadow-md);
  position: sticky;
  top: 20px;
  height: auto;
  min-height: calc(100vh - var(--header-height, 100px) - 40px);
  z-index: 100;
}

.nav-list {
  list-style: none;
  position: relative;
}

.nav-item {
  border-bottom: 1px solid rgba(255, 255, 255, 0.35);
  position: relative;
  min-height: 60px;
}

.nav-item:last-child {
  border-bottom: none;
}

.nav-title {
  padding: 20px;
  font-weight: var(--font-weight-bold);
  color: var(--color-secondary);
  background-color: transparent;
  /* 与侧栏盒子背景统一：透出渐变 */
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease, transform 300ms ease-out, margin-bottom 300ms ease-out;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 10;
  height: 60px;
  font-size: 16px;
  box-sizing: border-box;
}

.toggle-icon {
  font-size: 12px;
  transition: transform 0.3s;
  transform: rotate(0deg);
}

.toggle-icon.expanded {
  transform: rotate(180deg);
}

.nav-title:hover {
  background-color: rgba(255, 255, 255, 0.18);
}

.sub-nav {
  list-style: none;
  margin: 0;
  padding: 0;
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  z-index: 20;
  background-color: rgba(255, 255, 255, 0.5);
  /* 容器半透明 */
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-top: none;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 4px 10px rgba(16, 24, 40, 0.08);
  width: 100%;
  box-sizing: border-box;
  height: 240px;
  overflow-y: auto;
  opacity: 0;
  pointer-events: none;
  max-height: 0;
  transition: opacity 300ms ease-out, max-height 300ms ease-out, padding 300ms ease-out, top 300ms ease-out;
}

.nav-item.expanded .nav-title {
  transform: translateY(8px);
}

.nav-item.expanded .sub-nav {
  top: calc(100% + 8px);
}

.sub-nav.expanded {
  opacity: 1;
  max-height: 240px;
  padding: 5px;
  pointer-events: auto;
  box-shadow: 0 6px 16px rgba(16, 24, 40, 0.12);
}

.sub-nav-item {
  padding: 16px 20px 16px 40px;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
  position: relative;
  z-index: 5;
  height: 56px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  font-size: 15px;
  min-height: 56px;
  background-color: var(--color-surface);
  border-bottom: 1px solid rgba(16, 24, 40, 0.06);
}

.sub-nav-item:hover {
  background-color: #f1f5ff;
  color: var(--color-secondary);
}

.sub-nav-item.active {
  background-color: #e6f0ff;
  color: var(--color-secondary);
  font-weight: var(--font-weight-bold);
}

/* 触控反馈 */
.nav-title:active {
  background-color: rgba(255, 255, 255, 0.25);
}

.sub-nav-item:active {
  background-color: #eaf1ff;
}

/* 覆盖为流式展开，不遮挡其他一级菜单 */
.nav-item.expanded .nav-title {
  margin-bottom: 8px;
  transform: none;
}

.sub-nav {
  position: relative !important;
  left: auto !important;
  right: auto !important;
  top: auto !important;
  height: auto;
  overflow: visible;
}

.sub-nav.expanded {
  opacity: 1;
  max-height: 999px;
  padding: 5px;
  pointer-events: auto;
  box-shadow: 0 6px 16px rgba(16, 24, 40, 0.12);
}

.nav-item.expanded .sub-nav {
  top: auto !important;
}

@media (max-width: 768px) {
  .sidebar {
    width: 100%;
    position: static;
    top: auto;
    min-height: auto;
  }
}
</style>
